"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.count = count;
exports.default = void 0;
exports.getCustStatistics = getCustStatistics;
exports.numCustIds = numCustIds;
exports.queryStatus = queryStatus;
exports.stat = stat;

var _request = _interopRequireDefault(require("@/utils/request"));

var _qs = _interopRequireDefault(require("qs"));

function count(data) {
  return (0, _request.default)({
    url: 'api/statCust?' + data,
    method: 'get',
    data: data
  });
}

function queryStatus(data) {
  return (0, _request.default)({
    url: 'api/statCust/?' + data,
    data: data
  });
}

function stat(data) {
  return (0, _request.default)({
    url: 'api/statCust/stat' + '?' + _qs.default.stringify(data, {
      indices: false
    }),
    method: 'get'
  });
}

function numCustIds(data) {
  return (0, _request.default)({
    url: 'api/statCust/getNumCustIds' + '?' + _qs.default.stringify(data, {
      indices: false
    }),
    method: 'get'
  });
}

function getCustStatistics(params) {
  return (0, _request.default)({
    url: 'api/cust/getCustStatistics',
    method: 'get',
    params: params
  });
}

var _default = {
  count: count,
  queryStatus: queryStatus,
  stat: stat,
  numCustIds: numCustIds,
  getCustStatistics: getCustStatistics
};
exports.default = _default;